import { Outlet } from "react-router-dom";
import { useEffect, useRef } from "react";
import Header from "./Header";
import { pageShell } from "../styles/pageShell";

export default function DashboardLayout() {
    const headerRef = useRef(null);

    useEffect(() => {
        const updateHeaderHeight = () => {
            if (headerRef.current) {
                const headerHeight = headerRef.current.offsetHeight;
                document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
            }
        };

        // 初期設定
        updateHeaderHeight();

        // リサイズ時に再計算
        const resizeObserver = new ResizeObserver(updateHeaderHeight);
        if (headerRef.current) {
            resizeObserver.observe(headerRef.current);
        }

        // クリーンアップ
        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <div className={pageShell.layout}>
            <Header ref={headerRef} />
            <main className={pageShell.main}>
                <Outlet />
            </main>
        </div>
    );
}
